import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { PURCHASE_STATUS_OPTIONS } from "../marketplace/marketplaceUtils";

const InvoiceFilters = ({
  search,
  onSearchChange,
  onSearchSubmit,
  statusFilter,
  onStatusFilterChange,
  timeFilter,
  onTimeFilterChange,
  openTimeDropdown,
  onToggleTimeDropdown,
}) => {
  return (
    <div className="rounded-lg border border-slate-200 bg-white p-4 shadow-sm">
      <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
        <div className="flex min-h-11 w-full max-w-xl items-center gap-3 rounded-lg border border-slate-200 bg-slate-50 px-3 text-slate-500 focus-within:border-slate-400 focus-within:bg-white">
          <FontAwesomeIcon icon={faSearch} onClick={onSearchSubmit} style={{ cursor: "pointer" }} />
          <input
            type="text"
            className="w-full bg-transparent text-sm text-slate-700 outline-none placeholder:text-slate-400"
            placeholder="Search by reference"
            value={search}
            onChange={(e) => onSearchChange(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                onSearchSubmit();
              }
            }}
          />
        </div>
        <div className="flex items-center gap-2">
          <select
            className="min-h-11 rounded-lg border border-slate-200 bg-white px-3 text-sm font-medium text-slate-700 outline-none"
            value={statusFilter}
            onChange={(e) => onStatusFilterChange(e.target.value)}
          >
            {PURCHASE_STATUS_OPTIONS.map((option) => (
              <option key={option.value || "all"} value={option.value || "all"}>
                {option.label}
              </option>
            ))}
          </select>
          {/* Time filter actions dropdown */}
          <div className="relative">
            <button
              className="flex h-11 w-11 items-center justify-center rounded-lg border border-slate-200 bg-white text-slate-500 hover:bg-slate-50 hover:text-slate-700 transition-colors"
              onClick={(e) => {
                e.stopPropagation();
                onToggleTimeDropdown();
              }}
              title="Filter by period"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
              </svg>
            </button>
            {openTimeDropdown === "actions" && (
              <div className="absolute right-0 top-12 z-50 min-w-[140px] rounded-lg border border-slate-200 bg-white py-1 shadow-lg">
                <div className="border-b border-slate-100 px-3 py-1.5 text-xs font-semibold text-slate-500 uppercase tracking-wide">
                  Period
                </div>
                {["all", "yearly", "monthly", "weekly", "daily"].map((opt) => (
                  <button
                    key={opt}
                    className={`block w-full px-3 py-1.5 text-left text-sm font-medium transition-colors hover:bg-slate-50 ${
                      timeFilter === opt ? "text-blue-600 bg-blue-50" : "text-slate-700"
                    }`}
                    onClick={() => {
                      onTimeFilterChange(opt);
                    }}
                  >
                    {opt === "all" ? "All Time" : opt.charAt(0).toUpperCase() + opt.slice(1)}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoiceFilters;